import { render, staticRenderFns } from "./CompanyBrandImage.vue?vue&type=template&id=03bb7303"
import script from "./CompanyBrandImage.vue?vue&type=script&lang=ts"
export * from "./CompanyBrandImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports